import React, { useState, useRef } from 'react'
import api from '../../../services/api'
import NotificationAlert from 'react-notification-alert'
import SimpleHeader from '../../../components/Headers/SimpleHeader'
import Filters from './Filters'
import Table from './Table'
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Form,
} from 'reactstrap'

const TIPOS = [
  { value: 'info', label: 'Informação' },
  { value: 'success', label: 'Sucesso' },
  { value: 'warning', label: 'Aviso' },
  { value: 'danger', label: 'Erro / Crítico' },
]

function toLocalDatetimeInput(dateString) {
  if (!dateString) return ''
  const date = new Date(dateString)
  if (isNaN(date.getTime())) return ''
  const pad = (n) => String(n).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
}

export default function Alertas(props) {
  const notificationAlert = useRef()
  const [alertas, setAlertas] = useState([])
  const [pageProperties, setPageProperties] = useState({
    total: '0',
    perPage: 10,
    page: 1,
    lastPage: 1,
    loading: false,
  })
  const [lastSearch, setLastSearch] = useState({})

  const [modal, setModal] = useState(false)
  const [editandoId, setEditandoId] = useState(null)
  const [salvando, setSalvando] = useState(false)

  const [titulo, setTitulo] = useState('')
  const [mensagem, setMensagem] = useState('')
  const [tipo, setTipo] = useState('info')
  const [ativo, setAtivo] = useState(true)
  const [dataInicio, setDataInicio] = useState('')
  const [dataFim, setDataFim] = useState('')
  const [linkUrl, setLinkUrl] = useState('')
  const [linkTexto, setLinkTexto] = useState('')
  const [isPrivate, setIsPrivate] = useState(false)

  function notify(type, msg) {
    const options = {
      place: 'tc',
      message: <div className="alert-text"><span data-notify="message">{msg}</span></div>,
      type,
      icon: 'ni ni-bell-55',
      autoDismiss: 7,
    }
    if (notificationAlert?.current) notificationAlert.current.notificationAlert(options)
  }

  async function updatePageProperties(response) {
    const { total, perPage, page, lastPage } = await response.data
    setPageProperties({
      total,
      perPage,
      page,
      lastPage,
      loading: false,
    })
  }

  async function load(
    page = 1,
    limit = 10,
    sortField = 'created_at',
    sortOrder = 'desc',
    filters = lastSearch
  ) {
    try {
      setPageProperties((p) => ({ ...p, loading: true }))
      const response = await api.get('common/alertas', {
        params: { page, limit, sortField, sortOrder, ...filters },
      })
      setAlertas(response.data.data || [])
      await updatePageProperties(response)
    } catch {
      notify('danger', 'Erro ao carregar alertas.')
      setPageProperties((p) => ({ ...p, loading: false }))
    }
  }

  function handleTableChange(type, { page, sizePerPage, sortField, sortOrder }) {
    load(page === 0 ? 1 : page, sizePerPage, sortField, sortOrder)
  }

  function limparForm() {
    setTitulo('')
    setMensagem('')
    setTipo('info')
    setAtivo(true)
    setDataInicio('')
    setDataFim('')
    setLinkUrl('')
    setLinkTexto('')
    setIsPrivate(false)
  }

  function abrirNovo() {
    limparForm()
    setEditandoId(null)
    setModal(true)
  }

  function abrirEditar(alerta) {
    setTitulo(alerta.titulo || '')
    setMensagem(alerta.mensagem || '')
    setTipo(alerta.tipo || 'info')
    setAtivo(alerta.ativo !== false)
    setDataInicio(toLocalDatetimeInput(alerta.data_inicio))
    setDataFim(toLocalDatetimeInput(alerta.data_fim))
    setLinkUrl(alerta.link_url || '')
    setLinkTexto(alerta.link_texto || '')
    setIsPrivate(alerta.is_private === true)
    setEditandoId(alerta.id)
    setModal(true)
  }

  async function salvar() {
    if (!titulo.trim() || !mensagem.trim()) {
      notify('warning', 'Preencha título e mensagem.')
      return
    }
    try {
      setSalvando(true)
      const payload = {
        titulo,
        mensagem,
        tipo,
        ativo,
        data_inicio: dataInicio || null,
        data_fim: dataFim || null,
        link_url: linkUrl || null,
        link_texto: linkTexto || null,
        is_private: isPrivate,
      }
      if (editandoId) {
        await api.put(`common/alertas/${editandoId}`, payload)
        notify('success', 'Alerta atualizado.')
      } else {
        await api.post('common/alertas', payload)
        notify('success', 'Alerta criado.')
      }
      setModal(false)
      load()
    } catch {
      notify('danger', 'Erro ao salvar alerta.')
    } finally {
      setSalvando(false)
    }
  }

  async function excluir(id) {
    if (!window.confirm('Deseja excluir este alerta?')) return
    try {
      await api.delete(`common/alertas/${id}`)
      notify('success', 'Alerta excluído.')
      load()
    } catch {
      notify('danger', 'Erro ao excluir alerta.')
    }
  }

  async function toggleStatus(alerta) {
    try {
      await api.put(`common/alertas/${alerta.id}`, { ...alerta, ativo: !alerta.ativo })
      notify('success', `Alerta ${alerta.ativo ? 'inativado' : 'reativado'} com sucesso.`)
      load()
    } catch {
      notify('danger', 'Erro ao alterar status.')
    }
  }

  return (
    <>
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlert} />
      </div>

      <SimpleHeader name="Listagem de Alertas" parentName="Alertas do Sistema" {...props} />

      <div className="w-100">
        <Row>
          <Col>
            <Card>
              <CardHeader
                style={{
                  position: 'sticky',
                  top: 0,
                  zIndex: 1,
                }}
              >
                <Filters
                  presets={() => (
                    <Button
                      color="primary"
                      type="button"
                      onClick={abrirNovo}
                      size="sm"
                    >
                      <span className="btn-inner--icon">
                        <i className="ni ni-fat-add" />
                      </span>
                      Novo Alerta
                    </Button>
                  )}
                  load={(filters) => {
                    setLastSearch(filters)
                    load(1, 10, 'created_at', 'desc', filters)
                  }}
                />
              </CardHeader>
              <CardBody>
                <Row>
                  <Col>
                    <Table
                      alertas={alertas || []}
                      pageProperties={pageProperties}
                      onTableChange={handleTableChange}
                      onEdit={abrirEditar}
                      onDelete={excluir}
                      onToggleStatus={toggleStatus}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      <Modal isOpen={modal} toggle={() => setModal(false)} size="lg">
        <ModalHeader toggle={() => setModal(false)}>
          {editandoId ? 'Editar Alerta' : 'Novo Alerta'}
        </ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label>Título</Label>
              <Input
                value={titulo}
                onChange={(e) => setTitulo(e.target.value)}
                placeholder="Ex: Nova funcionalidade disponível!"
              />
            </FormGroup>
            <FormGroup>
              <Label>Mensagem</Label>
              <Input
                type="textarea"
                rows={4}
                value={mensagem}
                onChange={(e) => setMensagem(e.target.value)}
                placeholder="Ex: Confira a nova funcionalidade do Copiloto!"
              />
            </FormGroup>
            <Row>
              <Col md={4}>
                <FormGroup>
                  <Label>Tipo</Label>
                  <Input
                    type="select"
                    value={tipo}
                    onChange={(e) => setTipo(e.target.value)}
                  >
                    {TIPOS.map((t) => (
                      <option key={t.value} value={t.value}>{t.label}</option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label>Status</Label>
                  <Input
                    type="select"
                    value={ativo ? 'true' : 'false'}
                    onChange={(e) => setAtivo(e.target.value === 'true')}
                  >
                    <option value="true">Ativo</option>
                    <option value="false">Inativo</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label>Visibilidade</Label>
                  <Input
                    type="select"
                    value={isPrivate ? 'true' : 'false'}
                    onChange={(e) => setIsPrivate(e.target.value === 'true')}
                  >
                    <option value="false">Público</option>
                    <option value="true">Privado</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Data de início <small className="text-muted">(opcional)</small></Label>
                  <Input
                    type="datetime-local"
                    value={dataInicio}
                    onChange={(e) => setDataInicio(e.target.value)}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Data de término <small className="text-muted">(opcional)</small></Label>
                  <Input
                    type="datetime-local"
                    value={dataFim}
                    onChange={(e) => setDataFim(e.target.value)}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={8}>
                <FormGroup>
                  <Label>URL do link <small className="text-muted">(opcional)</small></Label>
                  <Input
                    value={linkUrl}
                    onChange={(e) => setLinkUrl(e.target.value)}
                    placeholder="Ex: /admin/copiloto ou https://..."
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label>Texto do link</Label>
                  <Input
                    value={linkTexto}
                    onChange={(e) => setLinkTexto(e.target.value)}
                    placeholder="Ex: Acesse aqui"
                  />
                </FormGroup>
              </Col>
            </Row>
            {(mensagem || linkUrl) && (
              <FormGroup>
                <Label>Prévia</Label>
                <div
                  style={{
                    background: '#f8f9fa',
                    border: '1px solid #dee2e6',
                    borderRadius: 4,
                    padding: '8px 12px',
                    fontSize: 14,
                  }}
                >
                  <span>{mensagem}</span>
                  {linkUrl && (
                    <span style={{ marginLeft: 6, fontWeight: 600, color: '#3498db', textDecoration: 'underline' }}>
                      {linkTexto || 'Clique aqui'}
                    </span>
                  )}
                </div>
              </FormGroup>
            )}
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModal(false)}>Cancelar</Button>
          <Button color="primary" onClick={salvar} disabled={salvando}>
            {salvando ? 'Salvando...' : 'Salvar'}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}
